import React from 'react';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import { makeStyles } from '@material-ui/core/styles';
import ConfigAccordionBase from './ConfigAccordionBase';
import { Text } from '../../1elements';
import CountryDropDown from '../../2compounds/Select/CountryDropDown';
import ProvinceDropDown from '../../2compounds/Select/ProvinceDropDown';
import MapZoomNumberField from '../../2compounds/MapZoomNumberField';
import GoogleImageSwitch from '../../../v2/components/GoogleImageSwitch';

const MapCentralizationAccordion = ({
  onEditMode,
  selectedCountry,
  setSelectedCountry,
  selectedProvince,
  setSelectedProvince,
  selectedCountryOriginal,
  selectedProvinceOriginal,
  mapZoomValue,
  setMapZoomValue
}) => {
  const classes = useStyles();
  const handleCountryChange = (country) => {
    setSelectedCountry(country);
    setSelectedProvince(null);
  };

  return (
    <ConfigAccordionBase label={'Centralization'} onEditMode={onEditMode}>
      <Box className={classes.root}>
        <Text type={'h8'}>Location</Text>
        <CountryDropDown
          onEditMode={onEditMode}
          value={onEditMode ? selectedCountry : selectedCountryOriginal}
          onChange={handleCountryChange}
        />
        <ProvinceDropDown
          onEditMode={onEditMode}
          value={onEditMode ? selectedProvince : selectedProvinceOriginal}
          selectedCountry={selectedCountry}
          onChange={setSelectedProvince}
        />
        <MapZoomNumberField
          max="16"
          min="3"
          value={mapZoomValue}
          setValue={setMapZoomValue}
          disabled={!onEditMode}
        />
      </Box>
      <Divider sx={{ my: '20px', width: '100%' }} />

      <GoogleImageSwitch onEditMode={onEditMode} />
    </ConfigAccordionBase>
  );
};

export default MapCentralizationAccordion;

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '1.3fr 0.7fr 0.7fr 0.7fr',
    gap: 20,
    alignItems: 'center',
    maxWidth: '98%'
  }
});
